import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React from 'react';
import { addMonths, cloneDate, formatDate, getStartOfMonth, isAfter, isSameMonth, isSameYear } from '../date_utils';
function generateMonthYears(minDate, maxDate) {
    const list = [];
    const currDate = getStartOfMonth(cloneDate(minDate));
    const lastDate = getStartOfMonth(cloneDate(maxDate));
    while(!isAfter(currDate, lastDate)){
        list.push(cloneDate(currDate));
        addMonths(currDate, 1);
    }
    return list;
}
export default class MonthYearDropdownOptions extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            monthYearsList: generateMonthYears(this.props.minDate, this.props.maxDate)
        };
    }
    renderOptions = ()=>this.state.monthYearsList.map((monthYear)=>{
            const monthYearPoint = monthYear.valueOf();
            const isSameMonthYear = isSameYear(this.props.date, monthYear) && isSameMonth(this.props.date, monthYear);
            return /*#__PURE__*/ React.createElement("div", {
                className: isSameMonthYear ? 'react-datepicker__month-year-option --selected_month-year' : 'react-datepicker__month-year-option',
                key: monthYearPoint,
                ref: monthYearPoint,
                onClick: this.onChange.bind(this, monthYearPoint)
            }, isSameMonthYear ? /*#__PURE__*/ React.createElement("span", {
                className: "react-datepicker__month-year-option--selected"
            }, "✓") : '', formatDate(monthYear, this.props.dateFormat));
        });
    onChange = (monthYear)=>this.props.onChange(monthYear);
    handleClickOutside = ()=>{
        this.props.onCancel();
    };
    render() {
        const dropdownClass = cx({
            'react-datepicker__month-year-dropdown': true,
            'react-datepicker__month-year-dropdown--scrollable': this.props.scrollableMonthYearDropdown
        });
        return /*#__PURE__*/ React.createElement("div", {
            className: dropdownClass
        }, this.renderOptions());
    }
}
MonthYearDropdownOptions.propTypes = {
    date: PropTypes.object.isRequired,
    dateFormat: PropTypes.string.isRequired,
    maxDate: PropTypes.object.isRequired,
    minDate: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    scrollableMonthYearDropdown: PropTypes.bool
};
